import { render, staticRenderFns } from "./BookCategoryCard.vue?vue&type=template&id=0b4a68ce&"
import script from "./BookCategoryCard.vue?vue&type=script&lang=ts&"
export * from "./BookCategoryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports